module.exports = __webpack_public_path__ + "static/media/1000932.aefc7f59.png";